/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { DocumentResponse, GetApiDocument400, GetApiDocument403 } from '../placementApi.schemas.ts';

import getApiDocumentMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation d'un document depuis Salesforce via un token chiffre. Le token contient les metadonnees du document et les informations du proprietaire.
 * @summary Recuperation d'un document salesforce
 */
export const getApiDocument = (documentToken: string, signal?: AbortSignal) => {
  return getApiDocumentMutator<DocumentResponse>({ url: `/api/document/${documentToken}`, method: 'GET', signal });
};

export const getGetApiDocumentQueryKey = (documentToken: string) => {
  return [`/api/document/${documentToken}`] as const;
};

export const getGetApiDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDocument>>,
  TError = GetApiDocument400 | GetApiDocument403,
>(
  documentToken: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDocumentQueryKey(documentToken);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDocument>>> = ({ signal }) =>
    getApiDocument(documentToken, signal);

  return {
    queryKey,
    queryFn,
    enabled: documentToken !== null && documentToken !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDocument>>>;
export type GetApiDocumentQueryError = GetApiDocument400 | GetApiDocument403;

export function useGetApiDocument<
  TData = Awaited<ReturnType<typeof getApiDocument>>,
  TError = GetApiDocument400 | GetApiDocument403,
>(
  documentToken: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocument>>,
          TError,
          Awaited<ReturnType<typeof getApiDocument>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDocument<
  TData = Awaited<ReturnType<typeof getApiDocument>>,
  TError = GetApiDocument400 | GetApiDocument403,
>(
  documentToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocument>>,
          TError,
          Awaited<ReturnType<typeof getApiDocument>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDocument<
  TData = Awaited<ReturnType<typeof getApiDocument>>,
  TError = GetApiDocument400 | GetApiDocument403,
>(
  documentToken: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un document salesforce
 */

export function useGetApiDocument<
  TData = Awaited<ReturnType<typeof getApiDocument>>,
  TError = GetApiDocument400 | GetApiDocument403,
>(
  documentToken: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocument>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDocumentQueryOptions(documentToken, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
